import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface SpinnerState {
  active: boolean;
  count: number;
  text: string;
}

const initialState: SpinnerState = {
  active: false,
  count: 0,
  text: 'Loading',
};

const spinnerSlice = createSlice({
  name: 'spinner',
  initialState,
  reducers: {
    show: (state, action: PayloadAction<string | undefined>) => {
      state.count += 1;
      state.active = true;
      if (action.payload) state.text = action.payload;
    },
    hide: (state) => {
      state.count = Math.max(0, state.count - 1);
      state.active = state.count > 0;
    },
  },
});

export const { show: showSpinner, hide: hideSpinner } = spinnerSlice.actions;
export default spinnerSlice.reducer;
